import { featureList } from "@/mocks/gossip";

export default function FeaturesSection() {
  return (
    <section id="play" data-anchor className="bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="mb-2 flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wider text-primary-600">
            <i className="ri-gamepad-line text-base" aria-hidden="true" />
            玩法唠嗑
          </p>
          <h2 className="text-2xl font-black text-foreground-950 md:text-4xl">四种姿势，怎么吃都香</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            不管你是想安静围观、畅快发言，还是找一群同好深聊，吃瓜m 都有对应的打开方式，总有一款适合当下的你。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featureList.map((f) => (
            <article
              key={f.title}
              className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-100/40 p-5 transition-colors hover:border-accent-300 hover:bg-accent-50"
            >
              <span className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-accent-600 text-2xl text-background-50 transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-110">
                <i className={f.icon} aria-hidden="true" />
              </span>
              <h3 className="text-lg font-bold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-800">
                <i className="ri-sparkling-2-line" aria-hidden="true" />
                {f.chip}
              </span>
            </article>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {[
            { icon: "ri-24-hours-line", title: "全天候在线", text: "无论早八还是深夜，热瓜和瓜友从不缺席。" },
            { icon: "ri-group-line", title: "同频共话", text: "用话题和兴趣连接彼此，陌生人也能聊成瓜友。" },
            { icon: "ri-flag-line", title: "理性氛围", text: "友善发言有人呼应，跑偏话题也有人温柔提醒。" },
          ].map((b) => (
            <div
              key={b.title}
              className="flex items-start gap-4 rounded-2xl bg-accent-100/70 px-5 py-5"
            >
              <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-accent-600 text-xl text-background-50">
                <i className={b.icon} aria-hidden="true" />
              </span>
              <div>
                <h3 className="text-base font-bold text-foreground-950">{b.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">{b.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}